import { useMemo } from 'react';
import { useStoreSelector } from 'v3/data/store';
import { PreferencesOptionsEnum } from 'v3/shared/enums/preferences-options-enum';

export const usePreferenceOptionActive = (option: PreferencesOptionsEnum): boolean => {
  const preferenceOptions = useStoreSelector(store => store.preferenceOption.preferenceOptions);

  const isActive = useMemo(() => {
    const found = preferenceOptions.find(item => item.label === option.toString());
    return !!found && found.active === true;
  }, [preferenceOptions, option]);

  return isActive;
};